import { render, staticRenderFns } from "./NoSelect.vue?vue&type=template&id=66831281"
import script from "./NoSelect.vue?vue&type=script&lang=js"
export * from "./NoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66831281')) {
      api.createRecord('66831281', component.options)
    } else {
      api.reload('66831281', component.options)
    }
    module.hot.accept("./NoSelect.vue?vue&type=template&id=66831281", function () {
      api.rerender('66831281', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/data/NoSelect.vue"
export default component.exports